"use strict";
import { schedule } from '../middleware/schedule.js';

function renderSchedule(events) {
  const $programmeAccordion = $("#programmeAccordion");
  $programmeAccordion.empty();
  events.forEach(event => {
    const eventHtml = generateEventHtml(event);
    $programmeAccordion.append(eventHtml);
  });
}

function generateEventHtml(event) {
  console.log(event)
  return `<div class="accordion-item ${event.id}-item">
      <h2 class="accordion-header" id="heading-${event.id}">
        <button class="accordion-button d-flex align-items-center" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-${event.id}" aria-expanded="true" aria-controls="collapse-${event.id}">
          <i class="fas fa-building me-3"></i>
          <span class="event-time ${event.id}-time fw-bold">${event.time}</span> - <span class="event-title ${event.id}-title">${event.title}</span> 
        </button>
      </h2>
      <div id="collapse-${event.id}" class="accordion-collapse collapse show" aria-labelledby="heading-${event.id}" data-bs-parent="#programmeAccordion">
        <div class="accordion-body">
          <p class="fs-6 mb-1 event-description ${event.id}-description">${event.description}</p>

          <div class="edit-form edit-${event.id}">
            <div class="d-flex mb-2">
              <input type="time" class="form-control me-2 edit-time" placeholder="Modifier l'heure" />
              <input type="text" class="form-control edit-title" placeholder="Modifier le titre" />
            </div>
            <textarea class="form-control mb-2 edit-description" placeholder="Modifier la description"></textarea>
            <div class="ps-3 pb-2 sub-events-container">
              ${event.subEvents ? event.subEvents.map((subEvent, index) => `
                <div class="subevent subevent-${subEvent.id}">
                  <p class="fs-6 mb-1"><span class="subevent-time fw-bold">${subEvent.time}</span> - <span class="subevent-title ${subEvent.id}-title">${subEvent.title}</span></p>
                  <div class="d-flex mb-2 gap-2">
                    <input type="time" class="form-control edit-time-sub" placeholder="Modifier l'heure" />
                    <input type="text" class="form-control edit-title-sub" placeholder="Modifier le titre" />
                    <div class="icon-container">
                      <i class="fas fa-trash delete-subevent-icon"></i>
                    </div>
                  </div>
                </div>
              `).join('') : ''}
            </div>
            <div class="icon-container mt-2">
              <i class="fas fa-plus add-subevent-icon"></i> <span class="small">Add Sub Event</span>
            </div>
            <div class="icon-container">
              <i class="fas fa-edit edit-icon"></i>
              <i class="fas fa-save save-icon"></i>
              <i class="fas fa-times cancel-icon"></i>
            </div>
          </div>
        </div>
      </div>
    </div>`;
}

function attachEventHandlers() {
  $('.accordion-button').on('click', function () {
    $(this).toggleClass('active');
  });

  $('.edit-icon').on('click', function () {
    const form = $(this).closest('.edit-form');
    const eventTime = form.closest('.accordion-item').find('.event-time').text().trim();
    const eventTitle = form.closest('.accordion-item').find('.event-title').text().trim();
    const eventDescription = form.closest('.accordion-item').find('.event-description').text().trim();

    form.find('input.edit-time').val(eventTime);
    form.find('input.edit-title').val(eventTitle);
    form.find('textarea.edit-description').val(eventDescription);

    form.find('.subevent').each(function () {
      const subEventTime = $(this).find('.subevent-time').text().trim();
      const subEventTitle = $(this).find('.subevent-title').text().trim();

      $(this).find('input.edit-time-sub').val(subEventTime);
      $(this).find('input.edit-title-sub').val(subEventTitle);
    });

    $(this).closest('.icon-container').addClass('editing');
    form.addClass('editing');
    form.find('.icon-container').addClass('editing');
  });

  $('.save-icon').on('click', function () {
    const form = $(this).closest('.edit-form');
    const newEventTime = form.find('input.edit-time').val().trim();
    const newEventTitle = form.find('input.edit-title').val().trim();
    const newEventDescription = form.find('textarea.edit-description').val().trim();

    form.closest('.accordion-item').find('.event-time').text(newEventTime);
    form.closest('.accordion-item').find('.event-title').text(newEventTitle);
    form.closest('.accordion-item').find('.event-description').text(newEventDescription);

    form.find('.subevent').each(function () {
      const newSubEventTime = $(this).find('input.edit-time-sub').val().trim();
      const newSubEventTitle = $(this).find('input.edit-title-sub').val().trim();

      $(this).find('.subevent-time').text(newSubEventTime);
      $(this).find('.subevent-title').text(newSubEventTitle);
    });

    $(this).closest('.icon-container').removeClass('editing');
    form.removeClass('editing');
    form.find('.icon-container').removeClass('editing');

    // Call schedule.updateEvent
    const eventId = form.closest('.accordion-item').attr('class').split(' ')[1].split('-')[0];
    schedule.updateEvent(eventId, {
      id: eventId,
      time: newEventTime,
      title: newEventTitle,
      description: newEventDescription,
      subEvents: form.find('.subevent').map(function () {
        return {
          time: $(this).find('.subevent-time').text().trim(),
          title: $(this).find('.subevent-title').text().trim()
        };
      }).get()
    });
  });

  $('.cancel-icon').on('click', function () {
    $(this).closest('.icon-container').removeClass('editing');
    $(this).closest('.edit-form').removeClass('editing');
    $(this).closest('.edit-form').find('.icon-container').removeClass('editing');
  });

  $('.delete-subevent-icon').on('click', function () {
    const subEvent = $(this).closest('.subevent');
    const form = $(this).closest('.edit-form');
    const eventId = form.closest('.accordion-item').attr('class').split(' ')[1].split('-')[0];
    const subEventId = subEvent.attr('class').match(/subevent-(\d+)/)?.[1];

    if (!subEventId) {
      console.error('Sub-event ID not found');
      return;
    }

    // Call deleteSubEvent
    schedule.deleteSubEvent(eventId, subEventId)
      .then(() => {
        subEvent.remove();
      })
      .catch(error => console.error('Error deleting sub-event:', error));
  });

  $('.add-subevent-icon').on('click', function () {
    const form = $(this).closest('.edit-form');
    const lastSubEventTime = form.find('.subevent').last().find('.subevent-time').text().trim() || form.closest('.accordion-item').find('.event-time').text().trim();
    const newSubEventTime = incrementTime(lastSubEventTime);
    const subEventCount = form.find('.subevent').length + 1;

    const newSubEvent = $(`
      <div class="subevent sub_event_${subEventCount}">
        <p class="fs-6 mb-1"><span class="subevent-time the-time fw-bold">${newSubEventTime}</span> - <span class="subevent-title the-title">sub_event ${subEventCount}</span></p>
        <div class="d-flex mb-2 gap-2">
          <input type="time" class="form-control edit-time-sub" placeholder="Modifier l'heure" />
          <input type="text" class="form-control edit-title-sub" placeholder="Modifier le titre" />
          <div class="icon-container">
            <i class="fas fa-trash delete-subevent-icon"></i>
          </div>
        </div>
      </div>
    `);

    form.find('.sub-events-container').append(newSubEvent);

    // Attach events to the new sub-event elements
    newSubEvent.find('.delete-subevent-icon').on('click', function () {
      $(this).closest('.subevent').remove();
    });

    // Automatically fill the input fields for the new sub-event if in edit mode
    if (form.hasClass('editing')) {
      newSubEvent.find('input.edit-time-sub').val(newSubEventTime);
      newSubEvent.find('input.edit-title-sub').val(`sub_event ${subEventCount}`);
    }

    // Call addSubEvent
    const eventId = form.closest('.accordion-item').attr('class').split(' ')[1].split('-')[0];
    schedule.addSubEvent(eventId, {
      id: `sub_event_${subEventCount}`,
      time: newSubEventTime,
      title: `sub_event ${subEventCount}`
    });
  });
}


export function initSchedule() {
  $("#schedule-container").load('../../components/schedule.html', function () {

    schedule.getSchedule()
      .then(events => {
        renderSchedule(events);
        attachEventHandlers();
      })
      .catch(error => console.error('Error loading schedule:', error));

  });
  console.log("fin : initSchedule")
}

function incrementTime(time) {
  const [hours, minutes] = time.split(':').map(Number);
  const newMinutes = (minutes + 30) % 60;
  const newHours = (hours + Math.floor((minutes + 30) / 60)) % 24;
  return `${String(newHours).padStart(2, '0')}:${String(newMinutes).padStart(2, '0')}`;
}